module.exports = __webpack_public_path__ + "img/rank-5.46df1eb.svg";